// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:767.98px){.view-job-details .bullet-inline-list[data-v-3464bbba]{margin-top:.5rem}.view-job-details .bullet-inline-list a[data-v-3464bbba]{display:block;margin-bottom:.0625rem}.view-job-details .bullet-inline-list a[data-v-3464bbba]:before{display:none}}.view-job-details .company-image[data-v-3464bbba]{max-width:100%}", ""]);
// Exports
module.exports = exports;
